import { extend } from 'vee-validate';

extend('greaterThanZero', {
  validate: async (value) => value > 0,
  message: 'Cena musí být víc než 0!'
});

extend('greaterThanOrEqualZero', {
  validate: async (value) => value >= 0,
  message: 'Cena musí být víc než -1!'
});

export default {};
